/**
 * Check if the current route is allowed when limits are exceeded.
 * Users can only access settings, datasources/destinations list pages (not details), and onboarding pages
 * when they are over their plan limits.
 *
 * @param pathname - The current pathname from useLocation()
 * @returns true if the route is allowed when over limit
 */
export const isLimitEnforcementAllowedRoute = (pathname: string): boolean => {
  // Allow settings (all subpages), datasources/destinations list pages (no details), and onboarding pages
  const allowedPattern = /^\/ws\/[^/]+\/(settings|connections\/(datasources|destinations)(?!\/)|onboarding)/;
  return allowedPattern.test(pathname);
};
